import _ from "lodash";
import { getPointsBalanceFromUser } from "./getPointsBalanceFromUser";

export function isCouponAvailableForGroup(coupon, user) {
  const userGroupIds = _.get(user, "loyaltyProfile.data.groupIds");
  const { groupIds, notGroupIds } = coupon;
  return Boolean(
    (_.isEmpty(groupIds) ||
      _.intersection(groupIds, userGroupIds).length) &&
      (!userGroupIds || !_.intersection(notGroupIds, userGroupIds).length),
  );
}

export function getAvailableAndLockedCoupons(pointBankCoupons, user) {
  const balance = getPointsBalanceFromUser(user) || 0;
  const filtered = _.filter(pointBankCoupons, (c) =>
    isCouponAvailableForGroup(c, user),
  );
  return _.partition(filtered, (c) => balance - (c.price || 0) >= 0);
}

export function getNextRewardInfo(pointBankCoupons, user) {
  if (!pointBankCoupons?.length) return null;
  const balance = getPointsBalanceFromUser(user) || 0;
  const filtered = _.filter(pointBankCoupons, (c) =>
    isCouponAvailableForGroup(c, user),
  );
  const sorted = _.sortBy(_.uniqBy(filtered, "price"), (c) => c.price);
  const next = _.find(sorted, (c) => c.price - balance > 0);
  if (!next) return null;
  return {
    pointsToNext: next.price - balance,
    title: _.get(next, "coupon.title"),
  };
}
